import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  ar: {
    translation: {
      nav: {
        home: 'الرئيسية',
        about: 'من نحن',
        products: 'المنتجات',
        cases: 'قبل وبعد',
        tips: 'نصائح',
        faq: 'أسئلة شائعة',
        contact: 'تواصل معنا',
        switch: 'English',
      },
      hero: {
        brand: 'دواكم',
        headline_1: 'نستورد الجودة',
        headline_2: 'لنصنع الثقة',
        description:
          'دواكم شركة تُعنى باستيراد مواد الطب التجميلي من أجود المناشئ العالمية، لتقديم منتجات موثوقة للأطباء والعيادات في العراق.',
        cta_products: 'استكشف المنتجات',
        cta_contact: 'تواصل معنا',
        scroll: 'اسحب للأسفل',
      },
      marquee: [
        'الجودة',
        'الاحترافية',
        'الثقة',
      ],
      about: {
        eyebrow: 'من نحن',
        heading: 'الجودة هي أساس عملنا',
        heading_2: 'وثقة عملائنا هي نجاحنا',
        body_1:
          'في دواكم، نؤمن بأن الطب التجميلي فنٌّ يقوم على العلم والثقة. لذلك نختار شركاءنا بعناية فائقة، ونستورد منتجات مرخصة من أعرق المصنّعين حول العالم.',
        body_2:
          'نعمل جنبًا إلى جنب مع الأطباء والعيادات في العراق لتوفير حلول تجميلية عالية الجودة، آمنة، وذات نتائج طبيعية ومستدامة.',
        stats: {
          brands: 'علامات عالمية',
          products: 'منتجات مختارة',
          clinics: 'عيادات ومراكز',
          years: 'سنوات من الخبرة',
        },
        clinics_title: 'شركاؤنا من العيادات والمراكز',
        clinics_note: 'يُعرض هنا شعارات العيادات المتعاملة معنا',
      },
      brands_section: {
        eyebrow: 'شركاؤنا العالميون',
        heading: 'علاماتنا التجارية',
        subheading:
          'اختر إحدى العلامات لاستكشاف مجموعة المنتجات الحصرية.',
        select: 'استكشف المجموعة',
        back: 'العودة إلى العلامات',
        brands: {
          otesaly: {
            name: 'أوتسالي',
            tagline: 'فن الحقن التجميلي',
            desc: 'منذ عام ١٩٩٣ — تُصنَّع منتجات ‎Otesaly®‎ في أفضل المختبرات المتخصصة في هذا المجال، والتي تتمتع بتاريخ عريق في تطوير وتصنيع منتجات تجديد البشرة.',
          },
          reanzen: {
            name: 'ريانزن',
            tagline: 'الشركة التي تملأ الجمال',
            desc: 'ريانزن شركة رائدة قائمة على البحث والتطوير، متخصصة في الاندماج الحيوي (Bio Convergence) في مجالَي الأجهزة الطبية ومستحضرات التجميل العلاجية.',
          },
          brand3: {
            name: 'بوتكس ريد توكس',
            tagline: 'Red Tox Botox',
            desc: 'بوتكس لإزالة التجاعيد.',
          },
          brand4: {
            name: 'BM Hyrunidase',
            tagline: 'مذيب فلر',
            desc: '',
          },
        },
      },
      products: {
        eyebrow: 'مجموعتنا',
        heading: 'منتجاتنا',
        subheading:
          'مجموعة مختارة بعناية من علاماتنا العالمية الشريكة.',
        learn_more: 'اعرف المزيد',
        name_prefix: 'منتج',
        placeholder_desc:
          'وصف مختصر أنيق للمنتج سيتم تحديثه لاحقًا من قبل فريق دواكم. يعكس هذا الوصف جودة المنتج ومصدره الموثوق.',
        benefits: ['نتائج طبيعية', 'أمان عالي', 'منشأ موثّق'],
      },
      cases: {
        eyebrow: 'النتائج',
        heading: 'قبل وبعد',
        subheading: 'نتائج حقيقية لعملائنا · اسحب المقبض لرؤية النتيجة',
        before: 'قبل',
        after: 'بعد',
        drag_hint: 'اسحب',
        disclaimer:
          '* النتائج تختلف من حالة إلى أخرى وتعتمد على تقييم الطبيب.',
      },
      tips: {
        eyebrow: 'نصائح',
        heading: 'نصائح خبراء دواكم',
        subheading: 'إرشادات موثوقة حول الفلر والبوتكس والعناية العامة قبل وبعد الجلسة.',
        open: 'اقرأ النصائح',
        close: 'إغلاق',
        preview_label: 'نصيحة سريعة',
        categories: {
          filler: {
            title: 'نصائح الفلر',
            teaser: 'كيف تحصلين على نتائج طبيعية تدوم لأطول فترة ممكنة بعد جلسة الفلر؟',
            tips: [
              'اختر طبيباً متخصصاً ومرخصاً واسأل عن اسم المنتج قبل بدء الجلسة.',
              'لا تعرّضي الوجه لحرارة الساونا أو الجيم أو أشعة الشمس المباشرة خلال أول 48 ساعة.',
              'ضعي كمادات باردة (وليست ثلجاً مباشراً) لمدة 10 دقائق كل ساعة في اليوم الأول للتقليل من التورم.',
              'تجنّبي مساج منطقة الحقن أو النوم على الوجه في أول ليلتين حتى يستقر الفلر.',
              'اشربي الماء بكثرة — الفلر المعتمد على حمض الهيالورونيك يعمل بأفضل شكل مع بشرة رطبة جيداً.',
              'النتيجة النهائية تظهر بعد 10–14 يوماً بعد امتصاص التورم — لا تتسرعي في الحكم.',
            ],
          },
          botox: {
            title: 'نصائح البوتكس',
            teaser: 'ماذا تفعلين قبل وبعد جلسة البوتكس لضمان نتائج آمنة ومتناسقة؟',
            tips: [
              'استشيري طبيباً معتمداً واحرصي على أن العيادة نظيفة ومتقيدة بمعايير التعقيم.',
              'تحققي من أن البوتكس أصلي، واسألي عن شهادة المنشأ.',
              'لا تستلقي ولا تنحني للأمام لمدة 4 ساعات بعد الحقن حتى لا ينتقل البوتكس لمناطق أخرى.',
              'لا تحرّكي عضلات الوجه المعالجة (رفع الحاجب، تجهم بسيط) خلال أول يوم بعد الحقن.',
              'تجنّبي التمارين الرياضية الشديدة والساونا لمدة 24 ساعة على الأقل بعد الجلسة.',
              'لا تضعي مكياجاً ثقيلاً أو تقومي بمساج على منطقة الحقن في نفس اليوم.',
              'بدء التأثير من اليوم الثالث ويظهر بالكامل بعد 10–14 يوماً، ويدوم عادة 3–6 أشهر.',
              'أعيدي الجلسة قبل زوال التأثير كلياً للحفاظ على المظهر الطبيعي ولنتيجة أفضل مع الوقت.',
            ],
          },
          general: {
            title: 'نصائح عامة',
            teaser: 'قواعد أساسية لأي إجراء تجميلي لتحصلي على تجربة آمنة ومريحة.',
            tips: [
              'استشيري طبيباً معتمداً واحرصي على أن العيادة نظيفة ومتقيدة بمعايير التعقيم.',
              'اطلبي رؤية عبوة المنتج المستخدم قبل فتحها للتأكد من سلامتها وأصالتها.',
              'أخبري الطبيب بأي أدوية أو حساسية أو حالة صحية قبل بدء أي إجراء.',
              'استخدمي واقياً شمسياً SPF 50 يومياً بعد أي جلسة لحماية البشرة من التصبّغ.',
              'رطّبي بشرتك جيداً واحرصي على نوم كافٍ وتغذية متوازنة لدعم النتائج.',
              'تجنّبي الجلسات المتقاربة أكثر من اللازم — أعطِي بشرتك وقتاً للاستجابة والتعافي.',
              'راجعي الطبيب فوراً إذا لاحظتِ ألماً شديداً، تغيّر لون، أو تورّماً غير طبيعي.',
            ],
          },
        },
      },
      faq: {
        eyebrow: 'أسئلة شائعة',
        heading: 'الأسئلة الأكثر شيوعًا',
        subheading: 'إجابات موثوقة من فريق دواكم عن أكثر الأسئلة تكرارًا حول الفيلر والبوتوكس.',
        more: 'اضغط لرؤية المزيد من الأسئلة',
        less: 'عرض أسئلة أقل',
        groups: {
          filler: {
            label: 'أسئلة الفيلر',
            items: [
              {
                q: 'شكد يبقى الفيلر قبل لا يذوب؟',
                a: 'مدة بقاء الفيلر تختلف حسب نوع المادة، المنطقة المحقونة، كمية الحقن واستجابة الجسم. بالنسبة لفيلر ربلنجن (Replengen)، قد تستمر النتيجة تقريبًا من 6 أشهر إلى سنة، وتختلف المدة من شخص لآخر حسب المنطقة وطبيعة الجسم وطريقة الحقن.',
              },
              {
                q: 'هل فيلر ربلنجن آمن؟',
                a: 'فيلر ربلنجن يمكن أن يكون آمنًا عندما يكون المنتج موثوقًا ويُحقن بواسطة طبيب أو أخصائي تجميل بالطريقة الصحيحة. لكنه مثل أي إجراء طبي قد يسبب تورمًا، كدمات أو ألمًا مؤقتًا، لذلك اختيار الطبيب مهم جدًا، وأن يكون المنتج كوريًا وليس صينيًا.',
              },
              {
                q: 'شنو الفرق بين الفيلر والبوتوكس؟',
                a: 'الفيلر يُستخدم غالبًا لتعويض الحجم أو تحديد بعض ملامح الوجه، بينما البوتولينوم توكسين يعمل بطريقة مختلفة عبر تقليل حركة عضلات معينة بصورة مؤقتة. اختيار الإجراء يعتمد على الهدف والحالة ويحدده الطبيب.',
              },
              {
                q: 'متى تبين نتيجة الفيلر؟',
                a: 'النتيجة الأولية غالبًا تظهر مباشرة بعد الحقن، لكن التورم والكدمات ممكن تأثر على الشكل بالأيام الأولى، لذلك النتيجة الأوضح تكون بعد هدوء المنطقة.',
              },
              {
                q: 'هل الحقن مؤلم؟',
                a: 'مستوى الألم يختلف حسب المنطقة والشخص، لكن فيلر ربلنجن يحتوي على ليدوكايين مخدّر يقلل الألم بشكل ملحوظ، وقد يستخدم الطبيب مخدرًا موضعيًا لتقليل الانزعاج أثناء الإجراء.',
              },
              {
                q: 'شكد أحتاج وقت حتى أرجع لنشاطي الطبيعي؟',
                a: 'كثير من الأشخاص يرجعون لنشاطاتهم الطبيعية بسرعة، لكن عادةً يُنصح بتجنب النشاط البدني الشديد خلال أول 24–48 ساعة لتقليل التورم والكدمات، حسب تعليمات الطبيب.',
              },
              {
                q: 'شنو الأشياء اللي لازم أنتبه لها بعد الحقن؟',
                a: 'اتبع تعليمات الطبيب، وتجنب الضغط أو العبث بالمنطقة إلا إذا نصحك بذلك. وإذا ظهر ألم غير طبيعي، تغير واضح بلون الجلد أو مشاكل بالرؤية، فهذه علامات تحتاج تقييم طبي عاجل.',
              },
              {
                q: 'هل ممكن يصير تحسس من الفيلر؟',
                a: 'نعم، رغم أن الحساسية ليست من المضاعفات الأكثر شيوعًا، إلا أنها ممكنة. بعض المواد قد تحتاج تقييمًا أو اختبار حساسية حسب طبيعة المنتج.',
              },
            ],
          },
          botox: {
            label: 'أسئلة البوتوكس',
            items: [
              {
                q: 'شكد تدوم نتيجة البوتوكس؟',
                a: 'عادةً تستمر نتائج البوتوكس التجميلي حوالي 3 إلى 6 أشهر، وقد تختلف المدة حسب المنطقة، الجرعة، قوة العضلات واستجابة الجسم. بعض الأشخاص ممكن تستمر عندهم النتيجة فترة أطول أو أقصر.',
              },
              {
                q: 'متى تبين نتيجة البوتوكس؟',
                a: 'ممكن تبدأ النتيجة بالظهور خلال 3–5 أيام، بينما النتيجة الكاملة غالبًا تحتاج حوالي 7–14 يومًا.',
              },
              {
                q: 'هل البوتوكس آمن؟',
                a: 'البوتوكس يُستخدم طبيًا وتجميليًا منذ سنوات، ويمكن أن يكون آمنًا عند استخدام منتج موثوق مثل بوتكس أوتسالي الفرنسي وإعطائه بواسطة مختص مؤهل أو طبيب وبجرعة وتقنية مناسبة. مثل أي إجراء طبي، توجد آثار جانبية ومضاعفات محتملة يجب مناقشتها مع الطبيب.',
              },
              {
                q: 'هل أگدر أدلّك المنطقة بعد الحقن؟',
                a: 'لا يُنصح بفرك أو تدليك المنطقة المحقونة، لأن ذلك يؤثر على مكان انتشار المادة. اتبع تعليمات الطبيب أو المختص الذي أجرى الحقن.',
              },
            ],
          },
        },
      },
      contact: {
        eyebrow: 'للتواصل',
        heading: 'تواصل معنا',
        subheading:
          'نحن هنا للإجابة عن استفساراتكم وبناء شراكات طويلة الأمد.',
        name: 'الاسم',
        email: 'البريد الإلكتروني',
        subject: 'الموضوع',
        message: 'الرسالة',
        send: 'إرسال الرسالة',
        sending: 'جاري الإرسال...',
        success: 'شكرًا لتواصلك، سيصلك ردنا قريبًا.',
        error: 'حدث خطأ ما، الرجاء المحاولة مرة أخرى.',
        info_email: 'البريد الإلكتروني',
        info_address: 'العنوان',
        info_socials: 'تابعنا',
        placeholder_email: 'info@dowakum.com',
        placeholder_address: 'العراق — بغداد',
      },
      floating: {
        label: 'تواصل معنا',
        instagram: 'إنستغرام',
        facebook: 'فيسبوك',
      },
      footer: {
        tagline: 'نستورد الجودة لنصنع الثقة.',
        nav: 'التنقّل',
        products: 'المنتجات',
        contact: 'تواصل',
        copyright: 'جميع الحقوق محفوظة لشركة دواكم',
      },
      loader: {
        brand: 'دواكم',
        tagline: 'ثقة · بلا حدود',
      },
    },
  },
  en: {
    translation: {
      nav: {
        home: 'Home',
        about: 'About',
        products: 'Products',
        cases: 'Before & After',
        tips: 'Tips',
        faq: 'FAQ',
        contact: 'Contact',
        switch: 'العربية',
      },
      hero: {
        brand: 'Dowakum',
        headline_1: 'Importing Quality,',
        headline_2: 'Building Trust',
        description:
          'Dowakum is an Iraqi company that imports premium aesthetic medicine products from the world\'s leading manufacturers — for trusted clinics and physicians across Iraq.',
        cta_products: 'Discover Products',
        cta_contact: 'Contact Us',
        scroll: 'Scroll',
      },
      marquee: [
        'Quality',
        'Craft',
        'Trust',
      ],
      about: {
        eyebrow: 'About',
        heading: 'Quality Is the Foundation of Our Work,',
        heading_2: 'and Client Trust Is Our Success',
        body_1:
          'At Dowakum, we believe aesthetic medicine is a craft built on science and trust. We select our partners with care and import certified products from the most respected manufacturers around the world.',
        body_2:
          'We work alongside doctors and clinics across Iraq to deliver aesthetic solutions that are safe, refined, and produce natural, lasting results.',
        stats: {
          brands: 'International Brands',
          products: 'Curated Products',
          clinics: 'Clinics & Centers',
          years: 'Years of Experience',
        },
        clinics_title: 'Trusted by Clinics & Centers',
        clinics_note: 'Partner clinic logos will be showcased here',
      },
      brands_section: {
        eyebrow: 'Our Global Partners',
        heading: 'Our Brands',
        subheading:
          'Select a brand to explore its exclusive product collection.',
        select: 'Explore Collection',
        back: 'Back to brands',
        brands: {
          otesaly: {
            name: 'Otesaly',
            tagline: 'The Art of Aesthetic Injection',
            desc: 'Since 1993, Otesaly® products are manufactured by the best qualified laboratories in this field, with a long history of developing and manufacturing skin rejuvenation products.',
          },
          reanzen: {
            name: 'Reanzen',
            tagline: 'The Company That Fills Beauty',
            desc: 'Reanzen is a leading R&D-centered bio convergence company in the medical device and cosmeceutical fields.',
          },
          brand3: {
            name: 'Red Tox Botox',
            tagline: 'Red Tox Botox',
            desc: 'Wrinkle-removing Botox.',
          },
          brand4: {
            name: 'BM Hyrunidase',
            tagline: 'Filler dissolver',
            desc: '',
          },
        },
      },
      products: {
        eyebrow: 'Collection',
        heading: 'Our Products',
        subheading:
          'A carefully curated collection from our world-leading partner brands.',
        learn_more: 'Learn More',
        name_prefix: 'Product',
        placeholder_desc:
          'An elegant short description of the product will be updated later by the Dowakum team. It reflects the quality and trusted origin of the product.',
        benefits: ['Natural Results', 'High Safety', 'Certified Origin'],
      },
      cases: {
        eyebrow: 'Results',
        heading: 'Before & After',
        subheading: 'Real Results From Our Clients · Drag the handle to reveal',
        before: 'Before',
        after: 'After',
        drag_hint: 'Drag',
        disclaimer:
          '* Results vary from case to case and depend on physician assessment.',
      },
      tips: {
        eyebrow: 'Tips',
        heading: 'Expert Advice from Dowakum',
        subheading: 'Trusted guidance on fillers, botox, and general care — before and after your session.',
        open: 'Read Tips',
        close: 'Close',
        preview_label: 'Quick Tip',
        categories: {
          filler: {
            title: 'Filler Tips',
            teaser: 'How to achieve the most natural, long-lasting results after a filler session.',
            tips: [
              'Choose a licensed, specialized physician and ask about the product brand before your session.',
              'Avoid heat (sauna, gym, direct sun) on the treated area during the first 48 hours.',
              'Apply cool compresses (not ice directly) for 10 minutes every hour on the first day to reduce swelling.',
              'Do not massage the treated area or sleep face-down for the first two nights so the filler settles properly.',
              'Drink plenty of water — hyaluronic-acid fillers perform best on well-hydrated skin.',
              'Final results appear 10–14 days later once the swelling resolves — do not judge the result too early.',
            ],
          },
          botox: {
            title: 'Botox Tips',
            teaser: 'What to do before and after a botox session to ensure safe, even results.',
            tips: [
              'Only consult a certified physician and make sure the clinic follows strict sterilization standards.',
              'Confirm the product is authentic and ask for the certificate of origin.',
              'Do not lie down or bend forward for 4 hours after injection to keep the botox from migrating.',
              'Do not activate the treated facial muscles (raising brows, frowning) during the first hour after injection.',
              'Avoid strenuous workouts and sauna for at least 24 hours after the session.',
              'Skip heavy makeup or facial massage on the treated area on the same day.',
              'Effect starts on day 3 and peaks in 10–14 days — typical duration is 3–6 months.',
              'Schedule your next session before the effect fully wears off to maintain a natural, consistent look over time.',
            ],
          },
          general: {
            title: 'General Tips',
            teaser: 'Essential rules for any aesthetic procedure — for a safe and comfortable experience.',
            tips: [
              'Only consult a certified physician and make sure the clinic follows strict sterilization standards.',
              'Ask to see the product packaging sealed before use to confirm authenticity and safety.',
              'Disclose any medications, allergies, or medical conditions to your doctor before any procedure.',
              'Use SPF 50 sunscreen daily after any session to protect the skin from pigmentation.',
              'Keep your skin hydrated and support results with proper sleep and balanced nutrition.',
              'Do not schedule sessions too close together — give your skin time to respond and heal.',
              'Contact your physician immediately if you notice severe pain, discoloration, or unusual swelling.',
            ],
          },
        },
      },
      faq: {
        eyebrow: 'FAQ',
        heading: 'Frequently Asked Questions',
        subheading: 'Trusted answers from the Dowakum team to the most common questions about fillers and botox.',
        more: 'View more questions',
        less: 'Show fewer questions',
        groups: {
          filler: {
            label: 'Filler Questions',
            items: [
              {
                q: 'How long does filler last before it dissolves?',
                a: 'Filler longevity varies by material type, treated area, injected amount, and your body\'s response. For Replengen filler, results typically last around 6 months to a year, varying from person to person depending on the area, body chemistry, and injection technique.',
              },
              {
                q: 'Is Replengen filler safe?',
                a: 'Replengen filler can be safe when the product is authentic and injected by a physician or licensed aesthetic practitioner using the correct technique. Like any medical procedure, it may cause temporary swelling, bruising, or mild pain — which is why choosing the right physician matters greatly, along with choosing a Korean-made product rather than a Chinese one.',
              },
              {
                q: 'What is the difference between filler and botox?',
                a: 'Filler is mostly used to restore volume or define facial features, while botulinum toxin works differently by temporarily relaxing specific muscles. The right procedure depends on your goal and condition, as determined by the physician.',
              },
              {
                q: 'When do filler results appear?',
                a: 'Initial results usually appear immediately after injection, but swelling and bruising can affect the look during the first days — the clearest result appears once the area settles.',
              },
              {
                q: 'Is the injection painful?',
                a: 'Pain levels vary by area and person, but Replengen filler contains lidocaine anesthetic that noticeably reduces pain, and the physician may also apply a topical anesthetic to minimize discomfort during the procedure.',
              },
              {
                q: 'How long until I can return to my normal routine?',
                a: 'Many people return to their normal activities quickly, but it is usually advised to avoid intense physical activity for the first 24–48 hours to reduce swelling and bruising, per your physician\'s instructions.',
              },
              {
                q: 'What should I watch out for after injection?',
                a: 'Follow your physician\'s instructions and avoid pressing or touching the area unless advised. If you experience abnormal pain, visible skin discoloration, or vision problems, these are signs requiring urgent medical evaluation.',
              },
              {
                q: 'Can filler cause an allergic reaction?',
                a: 'Yes — although allergies are not among the most common complications, they are possible. Some materials may require assessment or an allergy test depending on the product.',
              },
            ],
          },
          botox: {
            label: 'Botox Questions',
            items: [
              {
                q: 'How long do botox results last?',
                a: 'Cosmetic botox results typically last around 3 to 6 months, varying by area, dosage, muscle strength, and individual response. Some people may see results last longer or shorter.',
              },
              {
                q: 'When do botox results appear?',
                a: 'Results may start appearing within 3–5 days, while full results usually take about 7–14 days.',
              },
              {
                q: 'Is botox safe?',
                a: 'Botox has been used medically and cosmetically for years and can be safe when using a trusted product such as French Otesaly Botox, administered by a qualified practitioner or physician at the right dose and technique. Like any medical procedure, potential side effects and complications should be discussed with your physician.',
              },
              {
                q: 'Can I massage the area after injection?',
                a: 'Rubbing or massaging the injected area is not recommended, as it affects where the material spreads. Follow the instructions of the physician or practitioner who performed the injection.',
              },
            ],
          },
        },
      },
      contact: {
        eyebrow: 'Get in Touch',
        heading: 'Contact Dowakum',
        subheading:
          'We\'re here to answer your questions and build lasting partnerships.',
        name: 'Name',
        email: 'Email Address',
        subject: 'Subject',
        message: 'Message',
        send: 'Send Message',
        sending: 'Sending...',
        success: 'Thank you for reaching out — we\'ll get back to you soon.',
        error: 'Something went wrong, please try again.',
        info_email: 'Email',
        info_address: 'Address',
        info_socials: 'Follow us',
        placeholder_email: 'info@dowakum.com',
        placeholder_address: 'Iraq — Baghdad',
      },
      floating: {
        label: 'Contact Us',
        instagram: 'Instagram',
        facebook: 'Facebook',
      },
      footer: {
        tagline: 'Importing quality, building trust.',
        nav: 'Navigation',
        products: 'Products',
        contact: 'Contact',
        copyright: 'All Rights Reserved to Dowakum',
      },
      loader: {
        brand: 'Dowakum',
        tagline: 'Trust · Without Limits',
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'ar',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnObjects: true,
});

export default i18n;
